export default "__VITE_ASSET__e6ee4c6b__"